import type { StepType } from "@reactour/tour";
import { text } from "@quickpoint.me/shared";
import TourStepContent from "./wrapper";

const publishing: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent description={() => <strong>{text.tourSteps.publishingTitle}</strong>} />
		),
		position: "center",
	},
	{
		selector: "#action-control-publish",
		content: () => (
			<TourStepContent description={() => text.tourSteps.publishingSaveAndPublish} />
		),
	},
	{
		selector: "#action-control-qr",
		content: () => (
			<TourStepContent description={() => text.tourSteps.publishingShareWithLink} />
		),
		action: () => {
			const toggleShare = document.getElementById("action-control-qr");
			toggleShare?.click();
		},
	},
	{
		selector: "[data-testid='share-pdf-export']",
		content: () => (
			<TourStepContent description={() => text.tourSteps.publishingPdfExport} />
		),
		position: "top",
	},
];

export default publishing;
